<template>
  <div class="flex flex-row w-full h-24 text-white text-sm my-4 justify-around">
    <div class="">
      <a href="https://www.uv.uio.no"><img v-cache class="w-64 h-20" src="@/assets/icons/svg/uio.svg" /></a>
    </div>
    <div class="mt-4 flex flex-col">
      <div>
        <a
          class="hover:text-red-400"
          href="https://www.uv.uio.no/ils/forskning/prosjekter/verktoy-veiledning-nye-larere/"
        >
          Prosjektet Verktøy for veiledning
        </a>
        /
        <a
          class="hover:text-red-400"
          href="https://www.uv.uio.no/ils/forskning/prosjekter/verktoy-veiledning-viken/index.html"
        >
          Prosjektet Verktøy for veiledning med nyutdannede lærere
        </a>
        <br />
        <router-link style="" class="hover:text-red-400" to="/privacy">Personvernerklæring</router-link>
        /
        <a
          class="hover:text-red-400"
          href="https://uustatus.no/nb/erklaringer/publisert/74ac6409-3437-4609-ac5f-a56f0a6ec625"
        >
          Tilgjengelighetserklæring
        </a>
      </div>
    </div>
    <div class="mt-4 flex flex-col">
      <p>Kontakt oss på</p>
      <a class="hover:text-red-400" href="mailto:ils-vfv@ils.uio.no">ils-vfv@ils.uio.no</a>
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'FooterComponent',
    setup() {
      return {}
    },
  })
</script>
